var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1593",
    "data-name": "Rectangle 1593",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "status-svgrepo-com",
    d: "M18.981,5.907a1.352,1.352,0,0,1,1.762.74A10.814,10.814,0,0,1,5.4,20.14a1.352,1.352,0,1,1,1.333-2.352A8.11,8.11,0,0,0,18.241,7.669,1.352,1.352,0,0,1,18.981,5.907ZM2.887,12.792a8.235,8.235,0,0,0,.8,1.964,1.352,1.352,0,1,1-2.35,1.337A10.942,10.942,0,0,1,.273,13.481a1.352,1.352,0,0,1,2.614-.689Zm.356-8A1.352,1.352,0,0,1,3.73,6.643,8.166,8.166,0,0,0,2.909,8.6,1.352,1.352,0,1,1,.3,7.882,10.869,10.869,0,0,1,1.4,5.281,1.352,1.352,0,0,1,3.244,4.794ZM13.585.3a10.868,10.868,0,0,1,2.6,1.093,1.352,1.352,0,1,1-1.362,2.335,8.166,8.166,0,0,0-1.954-.821A1.352,1.352,0,0,1,13.585.3Zm-3.948.933a1.352,1.352,0,0,1-.962,1.652,8.236,8.236,0,0,0-1.964.8,1.352,1.352,0,0,1-1.337-2.35A10.94,10.94,0,0,1,7.986.275,1.352,1.352,0,0,1,9.638,1.237Z",
    transform: "translate(1.111 1.11)",
    fill: "#1dbbbe",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.15908bd867e32a5eaf51881cb2cdf026.svg";
export { ForwardRef as ReactComponent };